import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import cn from 'classnames';

import Context from '@bibliocommons/context';

import ModalHeadingContext from './ModalHeadingContext';

import './ModalHeader.scss';

export default function ModalHeader({ className, title, size }) {
  const { mobileApp } = useContext(Context);
  // Null when a ModalHeader is used outside a Modal; the id is simply omitted in that case.
  const heading = useContext(ModalHeadingContext);

  const registerHeading = heading?.registerHeading;
  useEffect(() => {
    registerHeading?.();
  }, [registerHeading]);
  const classNames = cn('cp-modal-header', className, {
    'modal-header--mobile-app': mobileApp,
    [`modal-header--${size}`]: !!size
  });

  return (
    <header className={classNames}>
      <h2 className="modal-header__title" id={heading?.headingId}>
        {title}
      </h2>
    </header>
  );
}

ModalHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.oneOf(['default', 'small', 'large'])
};
